// extracted by mini-css-extract-plugin
export default {"card":"style-module--card--HmtND"};